module.exports = __webpack_public_path__ + "static/img/chair-kp.6b4cf8f0.png";